import * as specParser from './specParser';

class SpecDocument {
  public static get filterExerciseName() {
    return specParser.filterExcerciseName;
  }

  public static get getTables() {
    return specParser.getTablesFromDocument;
  }

  public static get reformatTable() {
    return specParser.reformatTable;
  }

  public static get convertTables() {
    return specParser.convertTablesToSpec;
  }
}

export default SpecDocument;
